// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon {
  height: 45px;
  position: absolute;
  right: 20px;
  top: -2px;
  width: 45px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/forecasts-list/forecasts-list.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;AACF","sourcesContent":[".icon {\n  height: 45px;\n  position: absolute;\n  right: 20px;\n  top: -2px;\n  width: 45px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
